import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsZip = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M16.7140837.5H4.1509241v12.4449037h-1.6718427v6.5551972l1.6718427,1.6672049v2.3326942h17.3699946V5.3091546L16.7140837.5ZM17.0711767,2.2344501l2.712975,2.7129736h-2.712975s0-2.712975,0-2.7129736ZM3.1979038,18.7812785v-5.1175523h15.881339v5.1175523H3.1979038ZM20.8044172,22.7834958H4.8697465v-3.2833949h14.9283187v-6.5551972H4.8697465V1.2188224h11.4849274v4.4497434h4.4497434v17.11493Z"
        />
        <polygon
          points="8.7864177 17.4043884 10.5996758 14.7591879 10.5996758 14.3751849 8.0717845 14.3751849 8.0717845 14.9191703 9.7463799 14.9191703 9.7463799 14.9351799 7.906458 17.6070554 7.906458 17.9697047 10.6263396 17.9697047 10.6263396 17.4257194 8.7864177 17.4257194 8.7864177 17.4043884"
        />
        <rect
          x="11.1648677"
          y="14.3751849"
          width=".655973"
          height="3.5945198"
        />
        <path
          d="M14.6366551,14.6418449c-.229342-.1919789-.5813259-.2933123-1.0612957-.2933123-.4426519,0-.7679607.0319965-1.0026242.0746584v3.5465138h.6506403v-1.354608c.0853239.0160096.1973229.021331.3199874.021331.4639829,0,.8746383-.1226645,1.1359541-.3839803.202667-.1920015.3093219-.4746484.3093219-.8159667,0-.3359743-.138674-.6186438-.3519839-.7946357ZM13.5433629,16.1244614c-.13333,0-.2400075-.0053441-.3199874-.0266751v-1.2159566c.069337-.0159869.1973229-.0319965.3786589-.0319965.4532947,0,.7306428.2133325.7306428.6133224,0,.4212982-.2986791.6613058-.7893143.6613058Z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsZip;
